export enum WeightUnitOfMeasure {
    grams = 'g',
    kilograms = 'kg',
    ounces = 'oz',
    pounds = 'lbs'
}